import { getVuexDomainConfigs } from '@/config/domainRegistry'
import store from '@/config/store/store'
import { Module, ModuleOptions } from 'vuex'
import { StoreDomainConfig } from '@/config/domainRegistry/store/storeDomainConfig'

const createOptions = (moduleName: string): ModuleOptions => ({})

const registerModule = (moduleName: string, module: Module<any, any>): void => {
  store.registerModule(moduleName, module, createOptions(moduleName))
}

export const addDomainStoreModules = async () =>
  Promise.all(
    getVuexDomainConfigs().map(
      async ({ name, moduleFactory }: StoreDomainConfig) =>
        registerModule(name, await moduleFactory())
    )
  )
